import { CourseTemplate } from '@/course-templates/models/course-template.model';
import { 
  COURSE_TEMPLATE_ITEM_EDITION_MENU,
  COURSE_TEMPLATE_ITEM_MENU,
  COURSE_TEMPLATE_ITEM_PURCHASED_MENU,
  MENU_TEMPLATE_IDS,
  MY_COURSE_TEMPLATE_ITEM_MENU,
  TEMPLATE_SCOPE,
  COURSE_TEMPLATE_PURCHASE_MENU,
  COURSE_TEMPLATE_SHARED_WITH_MENU,
  COURSE_TEMPLATE_OWNER_MENU,
  COURSE_TEMPLATE_SHARED_WITH_SECTION_MENU,
  PURCHASE_TYPES } from '@/course-templates/values/course-templates.values';
  import { IResponseConfirmationModal } from '@/plugins/ed-modal/interfaces/response-confirmation-modal.interface';
import { EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import EdShareCourseComponent from '@/classes/components/ed-share-course/ed-share-course.component.vue'
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';
import KEYS from '@/values/keys';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';
import { ALL_CONTENT_ROUTES } from '@/app/private/my-content/views/all/all.router';
import { COURSE_MODE } from '@/courses/values/courses.values';
import { AuthProvider } from '@/auth/providers/auth.provider';
import { BUILD_SUBJECT_ROUTES } from '@/app/private/subjects/views/build-subject/build-subject.router';
import { CourseTemplateService } from '@/course-templates/services/course-templates.service';
import { MY_CONTENT_STORE } from '@/app/private/my-content/store/my-content.store';
import {TOAST_TYPES} from '@/plugins/ed-toast/values/ed-toast.values';

@Component({
  name: 'ed-course-template'
})
export default class EdCourseTemplateComponent extends Vue {
  @Inject()
  EduacAppSetLoading;

  @Prop() readonly menuName: string;
  @Prop() readonly isPurchased: boolean;
  @Prop() readonly labelHidden: boolean;
  @Prop() readonly courseTemplate: CourseTemplate;

  public saving: boolean = false;
  public isActionInProcess: boolean = false;
  public templateScope: string = TEMPLATE_SCOPE.ORGANIZATION;
  public statusTimeout = null;

  get author() {
    return `${this.$i18n.t('myContent.by')} ${this.courseTemplate.publisher.firstName}`;
  }

  get categories() {
    let categories = this.courseTemplate.categories;
    let names = '';
    categories.forEach((c, i) => names += i !== (categories.length - 1) ? `${c.name},` : c.name);
    return names;
  }

  get listMenu(): EdContextMenuOptionsModel[] {
    let menu;
    switch(this.courseTemplate?.userType) {
      case PURCHASE_TYPES.PURCHASE:
        menu = COURSE_TEMPLATE_PURCHASE_MENU;
      break;
      case PURCHASE_TYPES.SHARED_WITH:
        menu = COURSE_TEMPLATE_SHARED_WITH_MENU;
      break;
      case PURCHASE_TYPES.OWNER:
        menu = COURSE_TEMPLATE_OWNER_MENU;
      break;
      default:
        menu = COURSE_TEMPLATE_ITEM_MENU;
      break;
    }
    switch(this.menuName) {
      case 'edition':
        menu = COURSE_TEMPLATE_ITEM_EDITION_MENU;
      break;
      case 'purchased':
        menu = COURSE_TEMPLATE_ITEM_PURCHASED_MENU;
      break;
      case 'myTemplate':
        menu = MY_COURSE_TEMPLATE_ITEM_MENU;
      break;
      case 'editionShared':
        menu = COURSE_TEMPLATE_SHARED_WITH_SECTION_MENU;
      break;
    }
    return menu
      .filter(item => !item.hideForRoles || AuthProvider.isUserAllowed(item.hideForRoles))
      .map(item => {
        return new EdContextMenuOptionsModel(
          {...item, text: this.$i18n.t(item.text) }
        );
    });
  }

  get label() {
    return this.labelHidden ? '' : this.$i18n.t('bookstore.templatesView.template');
  }

  get iconFooter() {
    return this.isPurchased ? 'dollar' : '';
  }

  get iconFooterTooltip() {
    return this.isPurchased ? this.$i18n.t('myContent.templates.iconPurchasedTooltip') : '';
  }

  get progressLabel() {
    if (this.courseTemplate.isCopying) {
      return `${this.$i18n.t('myContent.contentItem.copying')}...`;
    }

    if (this.courseTemplate.hasError) {
      return `${this.$i18n.t('myContent.contentItem.error')}...`;
    }

    return '';
  }

  get progressColor() {
    if (this.courseTemplate.hasError) {
      return 'var(--ed-color-danger)';
    }

    return '';
  }

  onMenuSelected(optionSelected: EdContextMenuOptionsModel) {
    switch(optionSelected.id){
      case MENU_TEMPLATE_IDS.VIEW:
        this.goToView(COURSE_MODE.VIEW);
      break;
      case MENU_TEMPLATE_IDS.EDIT_CONTENT:
        this.goToView(COURSE_MODE.EDITION);
      break;
      case MENU_TEMPLATE_IDS.GET_SUBJECT:
        this.goToSubjectBuilder(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.MAKE_SUBJECT:
        this.makeSubject(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.BUILD_SUBJECT:
        this.goToBuildSubject(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.GET_TEMPLATE:
        this.buyTemplate(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.EDIT_PRODUCT:
        this.goToEditProduct();
      break;
      case MENU_TEMPLATE_IDS.PUBLISH:
        this.publishTemplateModal(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.TEMPLATE_ADMIN:
        this.templateAdminModal(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.REMOVE:
        this.removeCourseTemplate(this.courseTemplate);
      break;
      case MENU_TEMPLATE_IDS.SUBJECT_BUILDER:
        this.goToSubjectBuilderV2(this.courseTemplate);
      break;
      default:
        this.goToMyContentTemplates();
      break;
    }
  }


  goToView(mode) {
    const params: any = {
      courseId: this.courseTemplate.id.toString(),
      templateType: this.isPurchased ? 'purchased' : 'my',
    };
    if(mode === COURSE_MODE.EDITION) {
      params.mode = 'edit';
    }
    this.$router.push({ name: PRIVATE_ROUTES.SUBJECT_TEMPLATE.NAME, params });
  }

  goToEditContent() {
    this.$router.push({ name: PRIVATE_ROUTES.SUBJECT_TEMPLATE.NAME, params: {
      templateId: this.courseTemplate.id.toString(),
      section: this.isPurchased ? 'purchased' : 'my',
      mode: 'edit'
    }});
  }

  goToEditProduct() {
    this.$router.push({
      name: PRIVATE_ROUTES.CREATE_COURSE_TEMPLATE.NAME,
      params: {
        id: this.courseTemplate.id.toString()
      }
    });
  }

  goToSubjectBuilder(courseTemplate) {
    this.$router.push({
      name: PRIVATE_ROUTES.SUBJECT_BUILDER.NAME,
      params: {id: courseTemplate.id}
    });
  }

  goToSubjectBuilderV2(courseTemplate) {
    this.$router.push({
      name: PRIVATE_ROUTES.SUBJECT_BUILDER_V2.NAME,
      params: {id: courseTemplate.id}
    });
  }

  goToBuildSubject(courseTemplate) {
    this.$router.push({
      name: BUILD_SUBJECT_ROUTES.BUILD_SUBJECT_DESCRIPTION.NAME,
      params: {id: courseTemplate.id}
    });
  }

  publishTemplateModal(courseTemplate) {
    if (this.$store.getters['AuthStore/isAuthor']) {
      this.templateScope = TEMPLATE_SCOPE.PUBLIC;

      this.publishTemplate(courseTemplate.id, this.templateScope);
      return;
    }

    let title = String(this.$i18n.t('myContent.makeTemplate.confirmTemplate'));
    if(courseTemplate.published) title = String(this.$i18n.t('courseTemplates.publishTemplate.confirmUpdateTemplate'));
    this.$EdModal.createConfirmationModal({
      body: title,
      hasOptionRadio: true,
      firstOptionRadioText: String(this.$i18n.t('myContent.makeTemplate.private')),
      secondOptionRadioText: String(this.$i18n.t('myContent.makeTemplate.public')),
      actionText: String(this.$i18n.t('common.create')),
      action: (res: IResponseConfirmationModal) => {
        if(res.optionRadioValue != 'first') this.templateScope = TEMPLATE_SCOPE.PUBLIC;
        this.publishTemplate(courseTemplate.id, this.templateScope);
      }
    });
  }

  async buyTemplate(ct: CourseTemplate) {
    try {
      this.saving = true;
      await this.$CourseTemplates.Services.buyCourseTemplate(ct.id);
      await this.$CourseTemplates.Store.setChangesCourseTemplates();
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courseTemplates.buyTemplate.confirmTitle'),
        body: this.$i18n.t('courseTemplates.buyTemplate.confirmBody'),
        type: KEYS.EVENT_TYPES.SUCCESS
      });
      this.saving = false;
    } catch(err) {
      this.saving = false;
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('errors.ups'),
        body: this.$i18n.t('errors.errorSaving'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    }
  }

  async publishTemplate(templateId, templateScope) {
      try {
        this.saving = true;
        await this.$CourseTemplates.Store.publishCourseTemplate(
          { templateId, templateScope }
        );
        this.saving = false;
        this.$EdModal.createMessageModal({
          title: this.$i18n.t('myContent.makeTemplate.createdTitle'),
          body: this.$i18n.t('myContent.makeTemplate.createdBody'),
          type: KEYS.EVENT_TYPES.SUCCESS
        });
      } catch(err) {
        this.saving = false;
        if(err.status?.toString() == '400') {
          this.$EdModal.createMessageModal({
            title: this.$i18n.t('courseTemplates.errors.cantPublishTitle'),
            body: this.$i18n.t('courseTemplates.errors.cantPublish'),
            type: KEYS.EVENT_TYPES.DANGER
          });
        } else {
          this.$EdModal.createMessageModal({
            title: this.$i18n.t('courses.errors.errorTitle'),
            body: this.$i18n.t('myContent.makeTemplate.errorBody'),
            type: KEYS.EVENT_TYPES.DANGER
          });
        }
      }
  }

  async makeSubject(template: CourseTemplate) {
    try {
      this.EduacAppSetLoading(true);
      CourseTemplateService.copyToSubject(template.id, false);

      this.$store.commit(MY_CONTENT_STORE.MUTATIONS.INIT_COURSES);
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courseTemplates.courseCreated.title'),
        body: this.$i18n.t('courseTemplates.courseCreated.body'),
        type: KEYS.EVENT_TYPES.SUCCESS
      });

    } catch(error) {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: this.$i18n.t('myContent.makeSubject.errorBody'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    } finally {
      this.EduacAppSetLoading(false);
    }
  }

  async templateAdminModal(ct: CourseTemplate){
    try {
      const courseTemplates = await this.fetchMyCourseTemplates();
      const courseTemplate = this.getCourseTemplateById(courseTemplates, ct.id);
      this.$EdModal.createModal(EdShareCourseComponent, {course: courseTemplate, scope: 'template'});
    } catch (_) {
      this.$EdToast.create({
        msg:  `${this.$t('errors.errorGetData')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  getCourseTemplateById(templates, id) {
    const template = templates.find(t => t.id === id);
    return template || null;
  }

  async fetchMyCourseTemplates() {
    const response = await this.$CourseTemplates.Services.getMyCourseTemplates();
    return response?.courseTemplates || [];
  }

  removeCourseTemplate(ct: CourseTemplate) {
    this.$CourseTemplates.Store.removeCourseTemplate(ct.id)
  }

  goToMyContentTemplates() {
    this.$router.push({ name: ALL_CONTENT_ROUTES.TEMPLATES.NAME });
  }

  async checkCourseTemplateStatus() {
    if (this.courseTemplate.isCopying) {
      this.statusTimeout = setTimeout(async() => {
        await this.$CourseTemplates.Store.getCourseTemplateStatusById(this.courseTemplate.id);
        this.checkCourseTemplateStatus();
      }, 5000);
    }
  }

  created() {
    this.checkCourseTemplateStatus();
  }

  destroyed() {
    if (this.statusTimeout) {
      clearTimeout(this.statusTimeout);
    }
  }

}